const selects = document.querySelectorAll('[data-ref="programme-selects"]');
const compares = document.querySelectorAll('[data-ref="compare-selects"]');

if (selects && selects.length > 0) {
    selects.forEach(select => {
        select.addEventListener('change', e => {
            const selectedProgramme = e.target.value;
            const programmeContent = document.querySelectorAll(
                '[data-programme-id]',
            );

            programmeContent.forEach(programe => {
                if (selectedProgramme === programe.dataset.programmeId) {
                    programe.classList.add('show');
                } else {
                    programe.classList.remove('show');
                }
            });
        });
    });
}
if (compares && compares.length > 0) {
    compares.forEach(compare => {
        compare.addEventListener('change', e => {
            const compareProgramme = e.target.value;

            const programmeContent = document.querySelectorAll(
                '[data-compare-id]',
            );

            programmeContent.forEach(programe => {
                if (compareProgramme === programe.dataset.compareId) {
                    programe.classList.add('show');
                } else {
                    programe.classList.remove('show');
                }
            });
        });
    });
}
